
export const duplicateList = (list) =>{
    let newwList = [...list]
    if(list && list.length > 0 ){
        newwList= newwList.filter((item, pos) =>{
           return newwList.findIndex((obj)=>item === obj) === pos
        }) 
    }
    return newwList;
}